// extracted by mini-css-extract-plugin
export var content = "_bm-3";
export var list = "_bm-4";
export var settingsContent = "_bm-7";
export var settingsPanel = "_bm-8";
export var state = "_bm-6";
export var triggerBadge = "_bm-2";
export var triggerButton = "_bm-1";
export var triggerShell = "_bm-0";
export var unreadDot = "_bm-5";